import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { ConsoleService } from 'src/app/shared/services/console.service';
import gql from 'graphql-tag';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { PagoService } from 'src/app/services/pago.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import * as _ from 'lodash';
import { ControlResumidoService } from 'src/app/services/control-resumido.service';
//import { LiquidacionRecorridoComponent } from '../liquidacion-recorrido/liquidacion-recorrido.component';
import { CuentaBancariaService } from 'src/app/services/cuenta-bancaria.service';
import { BancoService } from 'src/app/services/banco.service';
import { DatesService } from 'src/app/shared/services/dates.service';

@Component({
  selector: 'app-modal-liquidacion-control-efectivo',
  templateUrl: './modal-liquidacion-control-efectivo.component.html',
  styleUrls: ['./modal-liquidacion-control-efectivo.component.scss'],
  providers: [SecurityService],
})
export class LiquidacionControlEfectivoComponent implements OnInit {
  @ViewChild('controlEfectivo', { static: true })
  controlEfectivoModal: ModalDirective;

  @Output() onControlEfectivoRealizado: EventEmitter<any> = new EventEmitter<any>();
  @Output() messageEvent = new EventEmitter<string>();

  // Diferencial: true = excedente, false = faltante

  // Forms
  formRecibidoHeader: FormGroup;
  formRecibidoDepositos: FormGroup;
  optionsBancosEmpresa: Array<any> = [];
  optionsCuentasBancosDeposito;
  listaDepositosRecibidos: Array<any> = [];
  totalDepositosRecibidos: number = 0;
  totalRecibidos: number = 0;
  formDiferencial: FormGroup;
  formCargoRuta: FormGroup;

  // Data &  Tmp
  private rutEmpresa: number;
  private sucursalEmpresa: number;
  private rutUsuario: number;
  resumen: any = null;
  declarante: any = null;
  mainData: any = null;
  listaClientes: Array<any> = [];
  recorrido: any = null;
  montoPagado: number = 0;
  montoTotalRecorrido: number = 0;
  montoCobroVendedor: number = 0;
  cerrandoLiq: boolean = true;
  processing: boolean = false;

  // Utils
  private log: any;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private usuarioService: UsuarioService,
    private rutService: RutService,
    private bancoService: BancoService,
    private cuentaBancariaService: CuentaBancariaService,
    private pagoService: PagoService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService,
    private controlResumidoService: ControlResumidoService,
    private datesService: DatesService //private liquidacionRecorrido: LiquidacionRecorridoComponent,
  ) {
    this.log = this.clog.log('REALIZAR-PAGOS-CABECERA-MODAL-CONTROL-EFECTIVO');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    this.getBancosEmpresas();
    this.createForms();
    this.formChangesSubscriptions();
  }

  sendMessage() {
    this.messageEvent.emit('ok');
  }
  private getBancosEmpresas() {
    this.bancoService.obtenerBancoEmpresas(this.rutEmpresa, true, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.optionsBancosEmpresa = registros.map((banco) => ({ value: banco.codigo, label: banco.nombre, ...banco }));
    });
  }

  private createForms() {
    this.formRecibidoHeader = this.fb.group({
      efectivo: [0, [Validators.required, Validators.min(0)]],
      dctoTransferencia: [0, [Validators.required, Validators.min(0)]],
      cheque: [0, [Validators.required, Validators.min(0)]],
    });
    this.formRecibidoDepositos = this.fb.group({
      monto: [null, [Validators.required, Validators.min(1)]],
      nroDeposito: [null, [Validators.required, Validators.min(1)]],
      fecha: [null, [Validators.required]],
      banco: [null, [Validators.required]],
      nroCuenta: [null, [Validators.required]],
    });
    this.formDiferencial = this.fb.group({
      cargoOrAbono: [false, []],
      monto: [0, [Validators.required, Validators.min(0)]],
      motivo: [null, []],
    });
    this.formCargoRuta = this.fb.group({
      monto: [0, [Validators.required, Validators.min(1)]],
      motivo: [null, []],
    });
  }

  /**
   * Normaliza montos provenientes de inputs con separadores de miles (ej: "731.939")
   * para que se interpreten como pesos enteros (731939) y no como decimales (731.939).
   */
  private toMonto(value: unknown): number {
    if (value === null || value === undefined) return 0;
    if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
    const raw = String(value).trim();
    if (!raw) return 0;

    // Quitar símbolos/espacios y dejar solo dígitos y signo
    // Nota: el input `monto` suele dejar el valor como string con puntos de miles.
    const isNegative = raw.startsWith('-');
    const digits = raw.replace(/[^\d]/g, '');
    if (!digits) return 0;
    const n = Number(digits);
    if (!Number.isFinite(n)) return 0;
    return isNegative ? -n : n;
  }

  private setMotivoRequired(required: boolean) {
    const motivoCtrl = this.formDiferencial.get('motivo');
    if (!motivoCtrl) return;
    motivoCtrl.setValidators(required ? [Validators.required] : []);
    motivoCtrl.updateValueAndValidity({ emitEvent: false });
    if (!required) {
      motivoCtrl.setValue(null, { emitEvent: false });
    }
  }

  private formChangesSubscriptions() {
    this.formRecibidoHeader.get('efectivo').valueChanges.subscribe((value) => {
      if (value !== null) this.calcularTotalesRecibidos(`formChangesSubscriptions efectivo ${value}`);
    });

    this.formRecibidoHeader.get('dctoTransferencia').valueChanges.subscribe((value) => {
      if (value !== null) this.calcularTotalesRecibidos(`formChangesSubscriptions dctoTransferencia ${value}`);
    });

    this.formRecibidoHeader.get('cheque').valueChanges.subscribe((value) => {
      if (value !== null) this.calcularTotalesRecibidos(`formChangesSubscriptions cheque ${value}`);
    });

    this.formRecibidoDepositos.get('banco').valueChanges.subscribe((banco_codigo) => {
      this.getCuentasDeposito(banco_codigo);
    });

    //this.formDiferencial.get("cargoOrAbono").valueChanges.subscribe(value => this.calcularTotalesRecibidos())
    //this.formDiferencial.get("monto").valueChanges.subscribe(value => this.calcularTotalesRecibidos())
    this.formCargoRuta.get('monto').valueChanges.subscribe((value) => {
      if (value !== null) this.calcularTotalesRecibidos(`formChangesSubscriptions monto ${value}`);
    });
  }

  getCuentasDeposito(banco_codigo) {
    this.cuentaBancariaService.obtenerCuentaEmpresa(this.rutEmpresa, banco_codigo, true, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.formRecibidoDepositos.get('nroCuenta').setValue(null);
      this.formRecibidoDepositos.get('nroCuenta').markAsPristine();
      this.formRecibidoDepositos.get('nroCuenta').markAsUntouched();
      this.optionsCuentasBancosDeposito = registros.map((cuenta) => ({ value: cuenta.numero_cuenta, label: cuenta.numero_cuenta, ...cuenta }));
    });
  }

  /********* SHOW/HIDE *********/
  show() {
    this.controlEfectivoModal.show();
  }

  hide() {
    // this.formData.reset()

    //LIMPIAR VARIABLES;
    this.listaDepositosRecibidos = [];
    this.resumen = null;
    this.totalRecibidos = 0;
    this.montoTotalRecorrido = null;
    this.montoPagado = null;
    this.montoCobroVendedor = null;
    this.totalDepositosRecibidos = 0;

    this.formCargoRuta.get('monto').setValue(null);
    this.controlEfectivoModal.hide();
  }
  /********* SHOW/HIDE *********/

  loadDataDeclarante() {
    this.usuarioService.obtenerSegunId(this.rutUsuario, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.declarante = respuesta;
      // console.log(respuesta)
      this.declarante.rutUsuarioFormato = this.rutService.AgregarDV(this.declarante.rut_usuario);
    });
  }

  limpiarForms() {
    this.totalRecibidos = 0;
    this.totalDepositosRecibidos = 0;
    this.formDiferencial.reset();
    this.formDiferencial.markAsPristine();
    this.formDiferencial.markAsUntouched();

    this.formCargoRuta.reset();
    this.formCargoRuta.markAsPristine();
    this.formCargoRuta.markAsUntouched();

    this.formRecibidoHeader.reset();
    this.formRecibidoHeader.markAsPristine();
    this.formRecibidoHeader.markAsUntouched();

    const now = this.datesService.CurrentDateToShortTimeString();
    this.formRecibidoDepositos.get('fecha').setValue(now);
    this.formRecibidoDepositos.reset();
    this.formRecibidoDepositos.markAsPristine();
    this.formRecibidoDepositos.markAsUntouched();

    this.limpiarFormRecibidoDepositos();
  }

  loadData(mainData, recorrido, montoPagado, montoTotalRecorrido, montoCobroVendedor) {
    // Puede ser tb en ngOnInit, pero lo dejo acá para depurar más fácil
    // this.loadDataDeclarante()
    this.show()

    this.limpiarForms();

    this.mainData = mainData;
    this.recorrido = recorrido;
    this.montoPagado = montoPagado;
    this.montoTotalRecorrido = montoTotalRecorrido;
    this.montoCobroVendedor = montoCobroVendedor;
    //this.log('mainData', JSON.stringify(mainData))

    this.loadDataDeclarante();

    this.mainData = mainData;
    this.log('mainData', JSON.stringify(mainData));

    // const inputParams = {
    //   entidad: {
    //     empresa_rut: this.rutEmpresa,
    //     sucursal_codigo: this.sucursalEmpresa,
    //     forma_pago: this.mainData.forma_pago, // TODO: Debería aceptar un array
    //     diferencial_pago: this.mainData.diferencial_pago
    //   }
    // }
    // FV: Se modifica debido a un cambio en payload para validarControlResume usado en MODAL-CONTROL-EFECTIVO
    const inputParams = {
      entidad: {
        pagos: [
          {
            empresa_rut: this.rutEmpresa,
            sucursal_codigo: this.sucursalEmpresa,
            forma_pago: this.mainData.forma_pago,
            diferencial_pago: this.mainData.diferencial_pago,
          },
        ],
      },
    };

    this.controlResumidoService.validarControlResume(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      respuesta.total_resumen += mainData.diferenciales[0];
      //respuesta.total_resumen = this.montoTotalRecorrido
      respuesta.monto_cheque += mainData.diferenciales[1] + mainData.diferenciales[6];
      respuesta.cantidad_transferencias += mainData.diferenciales[2] + mainData.diferenciales[7];
      respuesta.efectivo_recaudado += mainData.diferenciales[3] + mainData.diferenciales[5];
      this.resumen = respuesta;
      //this.resumen.monto_declarable = this.resumen.total_resumen - this.montoPagado
      this.resumen.monto_declarable = this.montoTotalRecorrido - this.montoPagado - this.montoCobroVendedor + this.resumen.diferencia_monto;
    });
  }

  setDefaultValues() {
    this.log('setDefaultValues', this.resumen);
    this.formRecibidoHeader.get('efectivo').setValue(this.resumen.efectivo_recaudado);
    this.formRecibidoHeader.get('dctoTransferencia').setValue(this.resumen.cantidad_transferencias);
    this.formRecibidoHeader.get('cheque').setValue(this.resumen.monto_cheque);
  }
  /********* DECLARACION RECIBIDO *********/
  agregarDepositoRecibido() {
    this.formValidatorsService.validateAllFormFields(this.formRecibidoDepositos);
    if (this.formRecibidoDepositos.invalid) return;

    // obtenre nombre banco
    const banco = this.optionsBancosEmpresa.find((p) => p.codigo === Number(this.formRecibidoDepositos.get('banco').value));
    if (!banco) {
      this.toastrService.error('Banco no encontrado');
      return;
    }

    this.listaDepositosRecibidos.push({
      monto: Number(this.formRecibidoDepositos.get('monto').value),
      numero_deposito: Number(this.formRecibidoDepositos.get('nroDeposito').value),
      // tipo_cuenta_bancaria_codigo
      banco_codigo: Number(this.formRecibidoDepositos.get('banco').value),
      banco_nombre: banco.nombre,
      numero_cuenta: this.formRecibidoDepositos.get('nroCuenta').value,
      fecha_deposito: this.formRecibidoDepositos.get('fecha').value,
    });
    this.listaDepositosRecibidos.map((deposito, index) => {
      deposito.index = index;
    });
    this.limpiarFormRecibidoDepositos();
    this.calcularTotalesDepositosRecibidos();
  }

  limpiarFormRecibidoDepositos() {
    this.formRecibidoDepositos.reset();
    // this.dtpFecha.clearDate()
    const now = this.datesService.CurrentDateToShortTimeString();
    this.formRecibidoDepositos.get('fecha').setValue(now);

    this.formRecibidoDepositos.markAsUntouched();
    this.formRecibidoDepositos.markAsPristine();
  }

  calcularTotalesDepositosRecibidos() {
    this.totalDepositosRecibidos = _.sumBy(this.listaDepositosRecibidos, 'monto');
    this.calcularTotalesRecibidos('calcularTotalesDepositosRecibidos');
  }

  calcularTotalesRecibidos(from: string) {
    //let montoDiferencial = Number(this.formDiferencial.get('monto').value)
    //if (this.formDiferencial.get('cargoOrAbono').value === this.TIPO_CARGO)
    //  montoDiferencial *= -1
    console.log(
      Number(this.formRecibidoHeader.get('efectivo').value),
      Number(this.formRecibidoHeader.get('dctoTransferencia').value),
      Number(this.formRecibidoHeader.get('cheque').value),
      Number(this.formCargoRuta.get('monto').value)
    );
    const efectivo = this.toMonto(this.formRecibidoHeader.get('efectivo').value);
    const transferencia = this.toMonto(this.formRecibidoHeader.get('dctoTransferencia').value);
    const cheque = this.toMonto(this.formRecibidoHeader.get('cheque').value);
    const cargoRuta = this.toMonto(this.formCargoRuta.get('monto').value);

    this.totalRecibidos = efectivo + transferencia + cheque + cargoRuta + this.totalDepositosRecibidos;

    // this.log('calcularTotalesRecibidos', from, this.resumen)
    const montoDeclarable = this.toMonto(this.resumen ? this.resumen.monto_declarable : 0);
    const montoDiferencial = Math.round(this.totalRecibidos - montoDeclarable);
    const esExcedente = montoDiferencial > 0;
    const montoAbs = Math.abs(montoDiferencial);

    this.formDiferencial.controls['monto'].setValue(montoAbs, { emitEvent: false });
    this.formDiferencial.controls['cargoOrAbono'].setValue(esExcedente, { emitEvent: false });
    this.setMotivoRequired(montoAbs > 0);

    console.log(this.formDiferencial.get('cargoOrAbono').value);
  }

  eliminarDepositoRecibido({ index }) {
    this.listaDepositosRecibidos = this.listaDepositosRecibidos.filter((deposito) => deposito.index !== index);
    this.calcularTotalesDepositosRecibidos();
  }
  /********* DECLARACION RECIBIDO *********/

  guardarPagos() {
    this.processing = true;
    const depositoControlEfectivo = _.cloneDeep(this.listaDepositosRecibidos);
    depositoControlEfectivo.forEach((deposito) => {
      delete deposito.index;

      // FIXME: It has to be done by backend first, then remove the next lines
      delete deposito.banco_codigo;
      delete deposito.banco_nombre;
      delete deposito.numero_cuenta;
      delete deposito.fecha_deposito;
    });
    delete this.recorrido.__typename;
    delete this.recorrido.rutChoferFormato;
    this.mainData.declaracionControl.vendedor_codigo = this.declarante.rut_usuario;
    /*
    const inputParams = {
      entidad: {
        declaracionControl: this.mainData.declaracionControl,
        pagos: [
          {
            saldoDocumento: this.mainData.saldoDocumento,
            difereciaPago: [],
            forma_pago: this.mainData.forma_pago,
            monto_coforme: this.mainData.monto_coforme,
          }
        ],
        controlEfectivo: {
          rut_usuario: this.rutEmpresa,
          monto_efectivo: Number(this.formRecibidoHeader.get('efectivo').value),
          monto_transferencia_recaudada: Number(this.formRecibidoHeader.get('dctoTransferencia').value),
          monto_cheque: Number(this.formRecibidoHeader.get('cheque').value),
          diferencia_tipo: this.formDiferencial.get('cargoOrAbono').value === this.TIPO_ABONO,
          motivo: this.formDiferencial.get('motivo').value,
          monto: Number(this.formDiferencial.get('monto').value),
          motivo_cargo_transportista: this.formCargoRuta.get('motivo').value,
          monto_cargo_transportista: Number(this.formCargoRuta.get('monto').value)
        },
        depositoControlEfectivo
      }
    }
    */

    const inputParams = {
      recorrido: this.recorrido,
      entidad: {
        declaracionControl: this.mainData.declaracionControl,
        pagos: this.mainData.pagos,
        controlEfectivo: {
          rut_usuario: this.rutUsuario,
          monto_efectivo: this.toMonto(this.formRecibidoHeader.get('efectivo').value),
          monto_transferencia_recaudada: this.toMonto(this.formRecibidoHeader.get('dctoTransferencia').value),
          monto_cheque: this.toMonto(this.formRecibidoHeader.get('cheque').value),
          diferencia_tipo: !!this.formDiferencial.get('cargoOrAbono').value,
          motivo: this.formDiferencial.get('motivo').value || '',
          monto: this.toMonto(this.formDiferencial.get('monto').value),
          motivo_cargo_transportista: this.formCargoRuta.get('motivo').value,
          monto_cargo_transportista: this.toMonto(this.formCargoRuta.get('monto').value),
          monto_devolucion: Number(this.montoPagado),
          monto_cobro_vendedor: this.montoCobroVendedor,
        },
        depositoControlEfectivo,
      },
    };
    this.log('guardarPagos', JSON.stringify(inputParams));

    this.pagoService.ControlDeEfectivoLiqRecorrido(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.processing = false;
        return;
      }
      // if (mensajes && mensajes.length > 0) {
      //   this.messageRendererService.showInfoMessages(mensajes)
      //   this.messageRendererService.showErrors(mensajes)
      //   return
      // }
      //this.liquidacionRecorrido.iniciarLiquidacion(1)
      this.processing = false;
      this.toastrService.success('Control efectivo realizado con éxito');
      this.onControlEfectivoRealizado.emit({
        input: inputParams,
        output: respuesta,
      });
      this.sendMessage();
      this.hide();
    });
  }

  setData(listaClientes, recorrido) {
    //this.listaClientes = listaClientes
    this.recorrido = recorrido;
  }

  /*
  setData(listaClientes, recorrido) {
    this.listaClientes = listaClientes
    this.recorrido = recorrido
  }

  guardarPagos() {
    this.cerrandoLiq = false
    //this.mainData.declaracionControl.vendedor_codigo = this.declarante.rut_usuario
    let controlEfectivo = {
      rut_usuario: this.rutEmpresa,
      monto_efectivo: Number(this.formRecibidoHeader.get('efectivo').value),
      monto_transferencia_recaudada: Number(this.formRecibidoHeader.get('dctoTransferencia').value),
      monto_cheque: Number(this.formRecibidoHeader.get('cheque').value),
      diferencia_tipo: this.formDiferencial.get('cargoOrAbono').value === this.TIPO_ABONO,
      motivo: this.formDiferencial.get('motivo').value,
      monto: Number(this.formDiferencial.get('monto').value),
      motivo_cargo_transportista: this.formCargoRuta.get('motivo').value,
      monto_cargo_transportista: Number(this.formCargoRuta.get('monto').value)
    }
    delete this.recorrido.__typename
    let inputParams = {
      recorrido : this.recorrido,
      listaDocumentos : [],
    }
    this.listaClientes.forEach(element => {
      inputParams.listaDocumentos.push({
        declaracionControl: this.mainData.declaracionControl,
        pagos: [
          {
            saldoDocumento: element.saldoDocumentos,
            difereciaPago: [],
            forma_pago: element.pagos,
            monto_coforme: element.monto_coforme,
          }
        ],
        controlEfectivo: {
          rut_usuario: this.rutEmpresa,
          monto_efectivo: controlEfectivo.monto_efectivo,
          monto_transferencia_recaudada: Number(this.formRecibidoHeader.get('dctoTransferencia').value),
          monto_cheque: Number(this.formRecibidoHeader.get('cheque').value),
          diferencia_tipo: this.formDiferencial.get('cargoOrAbono').value === this.TIPO_ABONO,
          motivo: this.formDiferencial.get('motivo').value,
          monto: Number(this.formDiferencial.get('monto').value),
          motivo_cargo_transportista: this.formCargoRuta.get('motivo').value,
          monto_cargo_transportista: Number(this.formCargoRuta.get('monto').value)
        },
        depositoControlEfectivo: [],
      })
    });
    if (this.totalRecibidos != this.resumen.total_resumen) {
      this.toastrService.error('El monto declarado es distinto al recibido.')
      this.cerrandoLiq = true
    }
    else {
      this.log('Control efectivo liquidacion recorrido inputParam', JSON.stringify(inputParams))
      this.pagoService.ControlDeEfectivoLiqRecorrido(inputParams, ({ mensajes, respuesta }) => {
        this.cerrandoLiq = true
        const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }
        this.toastrService.success(mensajes[0].texto)
        this.controlEfectivoModal.hide()
      })
    }
  }
  */
}
